import { useState, useEffect, useContext } from "react";
import { EditDisbatch } from "../../../contexts/edit";
import ClickAwayListener from "react-click-away-listener";
import styles from "./styles.module.css";

export default function Edit() {
  const [open, setOpen] = useState(false);
  const { undo, redo } = useContext(EditDisbatch);

  useEffect(() => {
    const onkeyDown = (e) => {
      if (e.ctrlKey && e.key === "z") {
        return undo();
      }
      if (e.ctrlKey && e.shiftKey && e.key === "Z") {
        return redo();
      }
    };

    window.addEventListener("keydown", onkeyDown);

    return () => {
      window.removeEventListener("keydown", onkeyDown);
    };
  }, []);

  const onUndo = () => {
    undo();
    setOpen(false);
  };
  const onRedo = () => {
    redo();
    setOpen(false);
  };
  return (
    <div style={{ position: "relative", marginLeft: 10 }}>
      <div onClick={() => setOpen(true)} className={styles.edit}>
        <div>Edit</div>
      </div>
      {open && (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <div className={styles.editDropdown}>
            <div onClick={onUndo} className={styles.editItem}>
              Undo (cmd z)
            </div>
            <div onClick={onRedo} className={styles.editItem}>
              Redo (cmd-⬆ Z)
            </div>
          </div>
        </ClickAwayListener>
      )}
    </div>
  );
}
